// Configuration for different environments
// 자동으로 환경 감지
const isDevelopment = process.env.NODE_ENV === 'development';
// localhost 비활성화
// const isLocalhost = typeof window !== 'undefined' && 
//   (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const isLocalhost = false;
const isProduction = process.env.NODE_ENV === 'production';

// 환경에 따른 API URL 결정
let API_BASE_URL;

// if (isDevelopment && isLocalhost) {
//   API_BASE_URL = 'http://localhost:8009';  // localhost 비활성화
// } else {
  API_BASE_URL = '/api';  // Express 서버 프록시 사용
// }

const config = {
  API_BASE_URL,
  
  // Alternative configurations for different environments (참고용)
  development: {
    // API_BASE_URL: 'http://localhost:8009'  // localhost 비활성화
    API_BASE_URL: '/api'
  },
  
  production: {
    API_BASE_URL: '/api'  // Express server proxy
  }
};

// Export the config
export default config;
